<template>
  <div id="tablesWrapper">
    <my-title>Tabellen</my-title>

    <div class="columns">
      <div class="column">
        <create-button
          caption="Nieuwe tabel"
          @click="edit(null)">
        </create-button>
      </div>
    </div>

    <div class="columns">
      <div class="column is-two-thirds">
        <aside class="menu">
          <table class="table is-fullwidth is-hoverable">
            <tr v-for="table in tables" :key="table.id" :class="{ 'has-background-primary': isActive(table.id) }">
              <td class="bundle-use-indicator">
                <span v-show="table.hasDatasets" class="icon is-small has-text-danger">
                  <i class="fas fa-circle"></i>
                </span>
              </td>
              <td class="name"><a :class="{ 'is-active': isActive(table.id) }" @click="select(table)">{{ table.name }}</a></td>

              <td>
                <div class="field is-grouped is-pulled-right">
                  <!-- TODO: The delete function isn't ready in the backend -->
                  <options-buttons
                    :deleting="false"
                    :navigating="[
                      {
                        icon: 'fas fa-file-alt',
                        title: 'Rapporten',
                         route: {
                          name: 'list-reports',
                          params: {
                            name: 'tableId',
                            value: table.id
                          }
                        }
                      },
                      {
                        icon: 'fas fa-link',
                        title: 'Contentpagina\s',
                        route: {
                          name: 'pages-admin',
                          params: {
                            name: 'tableId',
                            value: table.id
                          }
                        }
                      }
                    ]"
                    @edit="edit(table.id)"
                  ></options-buttons>
                </div>
              </td>
            </tr>
          </table>
        </aside>
      </div>

      <div class="column is-one-third">
        <h2 class="subtitle">Kolommen</h2>

        <article v-show="hasDatasets" class="message is-danger">
          <div class="message-header">
            <p>Deze tabel bevat datasets</p>
          </div>
          <div class="message-body">
            De kolommen van deze tabel zijn geblokkeerd omdat er datasets bestaan die bij deze tabel horen.
          </div>
        </article>

        <!-- TODO: The state is being changed here from within the component -->
        <table class="table is-striped">
          <tbody>
            <tr v-for="column in columns" :key="column.id">
              <td>{{ column.tabname }}</td>
              <td class="is-narrow">
                <input
                  type="checkbox"
                  class="checkbox"
                  :checked="isSelected(column)"
                  @click="toggle(column)"
                  :disabled="lockColumns || !table">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <edit-table
      :table="table"
      :isActive="showEdit"
      @save="save"
      @close="close"
    ></edit-table>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import MyTitle from '@/components/modules/Title'
import EditTable from '@/components/tables/EditTable'
import CreateButton from '@/components/modules/CreateButton'
import OptionsButtons from '@/components/modules/OptionsButtons'

export default {
  components: {
    MyTitle,
    EditTable,
    CreateButton,
    OptionsButtons
  },
  data () {
    return {
      checked: [],
      showEdit: false
    }
  },
  computed: {
    ...mapGetters({
      table: 'tables/table',
      tables: 'tables/tables',
      columns: 'columns/columns',
      bundles: 'bundles/bundles'
    }),
    lockColumns () {
      if (this.hasDatasets || this.table === null) return true

      return false
    },
    hasDatasets () {
      if (this.table) return this.table.hasDatasets

      return false
    }
  },
  methods: {
    isActive (recordId) {
      return (this.table) ? recordId === this.table.id : false
    },
    goToReports (tableId) {
      this.$router.push({
        name: 'list-reports',
        params: {
          tableId: tableId
        }
      })
    },
    select (table) {
      this.$store.commit('tables/SET_TABLE', table)
    },
    toggle (column) {
      if (this.isSelected(column)) {
        let index = _.findIndex(this.table.column_ids, function (o) { return o === column.id })
        this.table.column_ids.splice(index, 1)
      } else {
        this.table.column_ids.push(column.id)
      }

      if (this.table.id) this.save()
    },
    isSelected (column) {
      if (this.table) {
        return _.some(this.table.column_ids, function (id) {
          return id === column.id
        })
      }

      return false
    },
    edit (tableId) {
      this.$store.commit('tables/RESET')

      if (tableId) {
        this.$store.dispatch('tables/loadForAdmin', { id: tableId })
      }

      this.showEdit = true
    },
    close () {
      this.showEdit = false
    },
    save (payload) {
      if (payload) {
        this.$store.dispatch('tables/save', payload.name)
        this.close()
      } else {
        this.$store.dispatch('tables/save')
      }
    },
    remove (tableId) {
      this.$store.dispatch('tables/remove', tableId)
    }
  }
}
</script>

<style scoped>
  .name {
    vertical-align: middle;
  }

  .name a {
    color: inherit;
  }

  .bundle-use-indicator {
    vertical-align: middle;
  }
</style>
